import { useEffect, useState } from "react";
import { api, type Note } from "../lib/api";
import { NoteCard } from "../components/NoteCard";
import { QuickAdd } from "../components/QuickAdd";
import { Loader2 } from "lucide-react";

export function Inbox() {
  const [notes, setNotes] = useState<Note[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function load() {
    setLoading(true);
    setError("");
    try {
      const res = await api.getNotes({ limit: 50 });
      setNotes(res.notes);
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="px-4 pt-4 pb-28">
      <header className="mb-5">
        <h1 className="text-2xl font-bold tracking-tight">Cortex</h1>
        <p className="text-sm text-white/50 mt-1">Твой второй мозг</p>
      </header>

      {loading && (
        <div className="flex justify-center py-20">
          <Loader2 className="animate-spin text-accent" size={28} />
        </div>
      )}

      {error && (
        <div className="bg-red-500/10 text-red-300 text-sm rounded-xl p-4 mb-4">
          {error}
        </div>
      )}

      {!loading && notes.length === 0 && (
        <div className="text-center py-16 text-white/40">
          <p className="text-lg mb-2">Пока пусто</p>
          <p className="text-sm">Нажми + и кинь первую мысль</p>
        </div>
      )}

      <div className="space-y-3">
        {notes.map((n) => (
          <NoteCard key={n.id} note={n} />
        ))}
      </div>

      <QuickAdd onCreated={load} />
    </div>
  );
}